module.exports = require('./lib/_stream_duplex.js');



// WEBPACK FOOTER //
// ./~/readable-stream/duplex-browser.js